import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiMenus } from "~/routes"

import PageContainer from "~/library/PageContainer"
import MenuForm from "~/components/MenuForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import Menu from "~/types/Menu"

const EditMenu = () => {
  const [isMenuUpdated, setIsMenuUpdated] = useState<boolean>(false)

  const { id } = useParams<{ id: string }>()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiMenus.show.path({ venueSlug, id: id! })
  const { data: menu, isLoading } = useFetchResource<{ menu: Menu }, "menu">(endpoint, "menu", {})

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      id: id!,
      menu: formValues,
    }

    const req = apiMenus.update({ data })
    req
      .then(() => {
        setIsMenuUpdated(true)
        toast("Menu updated successfully", "success")
      })
      .catch((res) => {
        toast(
          `Error updating menu. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  if (isMenuUpdated) {
    return <Navigate to={`/menus/${id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Menu</h3>
          <LoadingWrapper isLoading={isLoading}>
            <MenuForm
              venueSlug={venueSlug}
              onSubmit={handleSubmit}
              initialValues={menu}
              isEditing={true}
            />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditMenu
